<template>
	<div class="join-pool-page">
		<div class="join-pool-page__content">
			<div class="join-pool-page__data">
				<h3 class="header">Join a Pool</h3>
				<p class="text-color--primary instructions">Please enter the details of the pool you with to join, along with the identifier and code that the manager sent you.</p>
				<form @submit.prevent="onSubmit">
					<div class="form-group">
						<select id="league" class="select-input input--primary font-size--medium" required v-model="selectedLeague" :disabled="!authenticated" :class="{ 'select-disabled': !authenticated }">
							<option value="League" disabled>Choose a League</option>
							<option v-for="(league, index) in leagues" :key="league.id" :value="index">{{ league.name }}</option>
						</select>
						<div class="requirements" v-if="leagueRequired">
							<ul>
								<li>Please make a selection</li>
							</ul>
						</div>
					</div>
					<div class="form-group">
						<select id="event" class="select-input input--primary font-size--medium" :class="{ 'select-disabled': eventDisabled }" required v-model="selectedEvent" :disabled="!authenticated">
							<option value="Event" disabled>Choose an Event</option>
							<option v-for="(event, index) in events" :key="event.id" :value="index">{{ event.name }}</option>
						</select>
						<div class="requirements" v-if="eventRequired">
							<ul>
								<li>Please make a selection</li>
							</ul>
						</div>
					</div>
					<div class="form-group">
						<select id="game" class="select-input input--primary font-size--medium" :class="{ 'select-disabled': gameDisabled }" required v-model="selectedGame" :disabled="!authenticated">
							<option value="Game" disabled>Choose a Game</option>
							<option v-for="(game, index) in games" :key="game.id" :value="index">{{ game.name }}</option>
						</select>
						<div class="requirements" v-if="gameRequired">
							<ul>
								<li>Please make a selection</li>
							</ul>
						</div>
					</div>
					<div class="form-group">
						<label class="join-pool__code-label" for="identifier">Pool Identifier</label>
						<div class="join-pool__code-group">
							<input id="identifier" class="join-pool__code-input" type="number" v-model="poolIdentifier1" required :disabled="!authenticated">
							<p class="text-color--primary-light-1 font-size--large">-</p>
							<input class="join-pool__code-input" type="number" v-model="poolIdentifier2" required id="pool-identifier-2" :disabled="!authenticated">
						</div>
					</div>
					<div class="form-group">
						<label class="join-pool__code-label" for="identifier">Pool Code</label>
						<div class="join-pool__code-group">
							<input id="code-1" class="join-pool__code-input" type="number" v-model="poolCode1" required max="999" name="code1" :disabled="!authenticated">
							<p class="text-color--primary-light-1 font-size--large">-</p>
							<input id="code-2" class="join-pool__code-input" type="number" v-model="poolCode2" required max="999" name="code2" :disabled="!authenticated">
						</div>
					</div>
					<div class="form-group" v-if="authenticated">
						<input class="btn btn--form-submit font-size--medium" type="submit" value="Join Pool">
					</div>
				</form>
				<div class="logged-out" v-if="!authenticated">
					<button class="auth-button auth-button--primary" @click="SET_LOGIN_REGISTER(true)">Please Login or Signup!</button>
				</div>
			</div>

			<div class="popup-info" v-if="showUserEnteredError">
				<div class="popup-info__message">
					<p>Sorry, you've already entered this pool! Go to your current pools to view it.</p>
					<div class="popup-info__message--bottom">
						<button class="font-size--medium text-color--secondary" @click="showUserEnteredError = false">Close</button>
					</div>	
				</div>
			</div>
			<div class="popup-info" v-if="showComboIncorrect">
				<div class="popup-info__message">
					<p>Sorry, that combination is incorrect! Please check that you entered all the info correctly, and reach out to the person that invited you if you need the info again!</p>
					<div class="popup-info__message--bottom">
						<button class="font-size--medium text-color--secondary" @click="showComboIncorrect = false">Close</button>
					</div>	
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapMutations, mapActions } from 'vuex'
	import axios from '../axios'

	export default {
		data() {
			return {
				selectedLeague: 'League',
				selectedEvent: 'Event',
				selectedGame: 'Game',
				poolIdentifier1: '',
				poolIdentifier2: '',
				poolCode1: '',
				poolCode2: '',
				leagueRequired: false,
				eventRequired: false,
				gameRequired: false,
				showUserEnteredError: false,
				showComboIncorrect: false
			}
		},
		computed: {
			...mapGetters([
				'leagues',
				'authenticated'
			]),
			eventDisabled() {
				return this.selectedLeague == 'League'
			},
			events() {
				if(this.selectedLeague == 'League') {
					return []
				} else {
					return this.leagues[this.selectedLeague].available_events
				}
			},
			gameDisabled() {
				return this.selectedEvent == 'Event'
			},
			games() {
				if(this.selectedEvent == 'Event') {
					return []
				} else {
					return this.leagues[this.selectedLeague].available_events[this.selectedEvent].available_games
				}
			},
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED',
				'SET_LOGIN_REGISTER'
			]),
			...mapActions([
				'getCurrentPools'
			]),
			onSubmit() {
				var data = {
					identifier: this.poolIdentifier1 + "-" + this.poolIdentifier2,
					join_code: this.poolCode1 + "-" + this.poolCode2
				}

				var apiPath = this.leagues[this.selectedLeague].available_events[this.selectedEvent].available_games[this.selectedGame].api_path + '/' + this.leagues[this.selectedLeague].available_events[this.selectedEvent].available_games[this.selectedGame].api_path.slice(0,-1) + '-entries'

				this.HTTP_IN_PROGRESS()
				axios.post(apiPath, data).then(response => {

					this.getCurrentPools().then(() => {
						this.$router.replace({ name:  this.leagues[this.selectedLeague].available_events[this.selectedEvent].available_games[this.selectedGame].api_path, params: { poolId: response.data.data.pool_id }})
					})
					
				}).catch(error => {
					if(error.response.data.code == 413) {
						this.showComboIncorrect = true
					}
					if(error.response.data.code == 414) {
						this.showUserEnteredError = true
					}
					this.HTTP_FINISHED()
				})
			}
		},
		watch: {
			selectedGame: function() {
				this.gameRequired = false
			},
			selectedLeague: function() {
				this.selectedEvent = 'Event'
				this.leagueRequired = false
			},
			selectedEvent: function() {
				this.selectedGame = 'Game'
				this.eventRequired = false
			}
		}
	}
</script>

<style lang="scss">
	@import '../styles/app';
	@import '../styles/views/joinPool';
</style>